import request from "@/utils/request"
// 车辆结构列表
export function getVehicleStructure() {
	return request({
		url: "/api/Mall/VehicleStructure",
		method: "post"
	})
}
// 品牌|车系|车组|车型
export function getBrandFamilyGroup(data) {
	return request({
		url: "/api/Mall/BrandFamilyGroupType",
		method: "post",
		data
	})
}
// 配件搜索列表
export function getQueryItemList(data) {
	return request({
		url: "/api/Mall/QueryItemList",
		method: "post",
		data
	})
}
// 店铺列表
export function getQueryStoreList(data) {
	return request({
		url: "/api/Merchant/QueryStoreList",
		method: "post",
		data
	})
}
// 配件已拆竞拍列表
export function getBaddingPartList(data) {
	return request({
		url: "/api/Auction/QueryAutoPartsAuction",
		method: "post",
		data
	})
}
// 配件已拆竞拍详情
export function getPartDetil(data) {
	return request({
		url: "/api/Auction/GetAutoPartsAuction",
		method: "post",
		data
	})
}
// 发动机竞拍列表
export function getBaddingStandingList(data) {
	return request({
		url: "/api/Auction/QueryStandingAuction",
		method: "post",
		data
	})
}
// 发动机竞拍详情
export function getStandingDetil(data) {
	return request({
		url: "/api/Auction/GetStandingAuction",
		method: "post",
		data
	})
}
//有色和轮胎竞拍列表
export function getBaddingWeightList(data) {
	return request({
		url: "/api/Auction/QueryWeightAuction",
		method: "post",
		data
	})
}
//有色和轮胎竞拍列表
export function getBaddingWeightDetil(data) {
	return request({
		url: "/api/Auction/GetWeightAuction",
		method: "post",
		data
	})
}
//热门搜索
export function getTopSearch(data) {
	return request({
		url: "/api/Home/TopSearch",
		method: "post",
		data
	})
}
//发货城市列表
export function GetFromCity(data) {
	return request({
		url: "/api/Mall/GetFromCity",
		method: "post",
		data
	})
}
